<template>
  <div class="wrapper">
    <h1>設定</h1>
    <div class="form">
      <p class="alert">
        はじめに、 <a href="https://docs.google.com/spreadsheets/d/1Dpo6MONqsIqU4Lo0PWyDwym41Uq9RTqR/edit?usp=sharing&amp;ouid=115812607673416459316&amp;rtpof=true&amp;sd=true" target="_blank" rel="noopener noreferrer">スプレッドシート</a> をご自身のドライブへコピーの保存して、バーコードを生成してください。
      </p>
      <div class="box">
        <h2>提出物</h2>
        <div class="table">
          <table v-show="!submissionsSetting">
            <tr>
              <th>ID</th>
              <th>提出物名</th>
            </tr>
            <tr v-for="(value, key) in localSubmissions" :key="key">
              <td>{{key}}</td>
              <td>{{value}}</td>
            </tr>
          </table>
          <button v-show="!submissionsSetting" v-on:click="submissionsSetting=!submissionsSetting">編集</button>

          <div class="edit" v-show="submissionsSetting">
            <p>スプレッドシートから直接貼り付けてください。</p>
            <textarea name="" id="" v-model="submissionsText"></textarea>
            <button @click="saveSubmissions">保存</button>
          </div>

        </div>
      </div>
      <div class="box">
        <h2>生徒</h2>
        <div class="table">
          <table v-show="!studentsSetting">
            <tr>
              <th>ID</th>
              <th>名前</th>
            </tr>
            <tr v-for="(value, key) in localStudents" :key="key">
              <td>{{key}}</td>
              <td>{{value}}</td>
            </tr>
          </table>
          <button v-show="!studentsSetting" v-on:click="studentsSetting=!studentsSetting">編集</button>

          <div class="edit" v-show="studentsSetting">
            <p>スプレッドシートから直接貼り付けてください。</p>
            <textarea name="" id="" v-model="studentsText"></textarea>
            <button @click="saveStudents">保存</button>
          </div>
        </div>
      </div>
      <div class="box">
        <h2>提出状況のデータ</h2>
        <div class="table">
          aaaa
        </div>
      </div>
      <div class="box">
        <h2>その他</h2>
        <div class="table">
          <label>表示間隔(秒): 
            <input type="number" v-model.number="localInterval" min="1" />
          </label>
          <label>スライド内容（改行区切り）:
            <textarea v-model="localSlides"></textarea>
          </label>
          <button @click="saveSettings">保存</button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  props: [
    "slides", "interval",
    "submissions", "students"
  ],
  data() {
    return {
      localSlides: this.slides.join("\n"),
      localInterval: this.interval / 1000,
      localSubmissions: this.submissions,
      localStudents: this.students,
      submissionsSetting: false, // 提出物編集の表示フラグ
      studentsSetting: false, // 生徒編集の表示フラグ
      submissionsText: '', // 提出物のtextarea
      studentsText: '' // 生徒のtextarea
    };
  },
  methods: {
    saveSettings() {
      this.$emit("update-settings", {
        slides: this.localSlides.split("\n").filter(s => s.trim() !== ""),
        interval: this.localInterval * 1000
      });
    },
    saveSubmissions() { // 提出物データの保存
      let submittions = this.submissionsText.split('\n');
      let ret = {}; // 返却用配列
      for(let i = 0; i < submittions.length; i++) {
        if( submittions[i] == '' ) break; // 空白行で終了
        
        let arr = submittions[i].split('\t');
        ret[arr[0]] = arr[1]; // ret[ID]=提出物名

      }
      console.log(ret);
      this.$emit("save-submissions", ret );
      this.localSubmissions = ret; // data 更新
      this.submissionsSetting = false; // 編集終了
    },
    saveStudents() { // 生徒データの保存
      let students = this.studentsText.split('\n');
      let ret = {}; // 返却用配列
      for(let i = 0; i < students.length; i++) {
        if( students[i] == '' ) break; // 空白行で終了
        
        let arr = students[i].split('\t');
        console.log(arr);
        ret[arr[1]*1] = arr[0]; // ret[ID]=氏名

      }
      console.log(ret);
      this.$emit("save-students", ret );
      this.localStudents = ret; // data更新
      this.studentsSetting = false; //編集終了
    }

  }
};
</script>

<style scoped>

html, body {
  width: auto;
}

.wrapper {
  margin: 100px auto 0 auto;
}

h1 {
    position: absolute;
    top: 0;
    left: 0;
    margin-left: 1em;
    font-size: 3vw;
    z-index: 1;
}

.form {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;
  padding: 20px;
  box-sizing: border-box;
  background-color: white;
  z-index: 2;
}

.form p.alert {
  padding: 20px 10px;
  width: 100%;
  background-color: #ddd;
  text-align: center;
}

.form .box {
  width: 45%;
}
.form .box h2 {
  font-size: 2vw;
}
.form .box table {
  width: 100%;
}
.form .box table th,
.form .box table td
 {
  padding: 5px 10px;
  border-bottom: #ddd 1px solid;
}
.form .box button {
  margin: 20px auto 0 auto;
  padding: 10px 20px;
  color: white;
  background: #222;
  border: none;
  outline: none;
  cursor: pointer;
}
.form .box textarea {
  width: 100%;
  height: 150px;
  line-height: 1.5;
}



</style>
